import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { isActeNatureOperation, NatureOperationId } from '@lib/models/graphqlData';
import { AuthService } from '@lib/services/auth-service.service';
import { OuiDialogService } from 'omnium-ui/dialog';
import { Subscription } from 'rxjs';
import { SelectConseilConfigDialogComponent } from 'src/app/components/create-fiche-conseil/select-conseil-config-dialog/select-conseil-config-dialog.component';

@Component({
  selector: 'app-create-fiche-conseil',
  templateUrl: './create-fiche-conseil.component.html',
  styleUrls: ['./create-fiche-conseil.component.scss'],
})
export class CreateFicheConseilComponent {
  isNotHabilitedWarning: boolean;
  userHabilitationCheckSubscription: Subscription;
  constructor(private router: Router, private dialogService: OuiDialogService, private authService: AuthService) {}

  ngOnInit() {
    this.userHabilitationCheckSubscription = this.authService.userHabilitationCheck.subscribe(value => {
      if (value) {
        this.isNotHabilitedWarning = !this.authService.isSomeHabilitationValid();
      }
    });
  }

  onCreateFiche() {
    const typeRef = this.dialogService.openDialog(SelectConseilConfigDialogComponent, {}, 'auto', 'auto');

    typeRef.afterClosed().subscribe(selectedFiche => {
      if (selectedFiche) {
        if (selectedFiche.nature_operation === NatureOperationId.Souscription)
          this.router.navigate(['fiche', selectedFiche.id]);
        else if (isActeNatureOperation(selectedFiche.nature_operation))
          this.router.navigate(['acte', selectedFiche.id]);
      }
    });
  }
}
